import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import { WS_ADD_NOTIFICATION_IN_LIST } from '../../actions/notifications';
import { serializeNotification } from '../../serializers/notifications';

class NotificationChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  update(): void {
    return undefined;
  }

  create(message: ISocketMessage): void {
    const notification = serializeNotification(message.data.notification);

    this.socketChannel.put({
      type: WS_ADD_NOTIFICATION_IN_LIST,
      payload: { notification },
    });
  }

  delete(): void {
    return undefined;
  }

  info(): void {
    return undefined;
  }
}

export default NotificationChannelHandler;
